import React, { useState, useEffect } from "react";
import {
  getSentMessagesByUser,
  deleteMessageById,
} from "../../services/messageServices";
import { BsEnvelopeArrowUpFill } from "react-icons/bs";
import ButtonDelete from "./../../components/Button/ButtonDelete";
import { toast } from "react-toastify";

const MessagesSent = ({ userId, refresh, setRefresh }) => {
  const [messages, setMessages] = useState([]);

  const loadMessages = async () => {
    if (!userId) {
      console.error("L'ID de l'utilisateur n'est pas trouvé");
      return;
    }
    try {
      const data = await getSentMessagesByUser(userId);
      const filteredMessages = (data || [])
        .filter((message) => message.is_copy)
        .sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        );
      setMessages(filteredMessages);
    } catch (error) {
      console.error("Erreur lors du chargement des messages:", error);
    }
  };

  useEffect(() => {
    loadMessages();
  }, [userId]);

  useEffect(() => {
    if (refresh) {
      loadMessages();
      setRefresh(false);
    }
  }, [refresh, setRefresh]);

  const promptDeleteMessage = (messageId) => {
    const confirmDelete = window.confirm(
      "Êtes-vous sûr de vouloir supprimer le message ?"
    );
    if (confirmDelete) {
      handleDeleteMessage(messageId);
    }
  };

  const handleDeleteMessage = async (messageId) => {
    try {
      await deleteMessageById(messageId);
      setMessages((prev) => prev.filter((m) => m.id !== messageId));
      toast.success("Message supprimé avec succès.");
    } catch (error) {
      console.error("Error deleting message:", error);
      toast.error("Erreur lors de la suppression du message.");
    }
  };

  return (
    <div className="w-full font-montserrat">
      <div className="flex items-center gap-2 mb-3">
        <BsEnvelopeArrowUpFill className="text-xl text-primary" />
        <h3 className="text-sm sm:text-base font-semibold">
          Messages envoyés
        </h3>
      </div>

      {messages.length === 0 ? (
        <div className="text-center py-4 text-sm bg-slate-50 dark:bg-slate-900/80 rounded-xl border border-dashed border-slate-300 dark:border-slate-700">
          Aucun message envoyé.
        </div>
      ) : (
        <>
          {/* Desktop */}
          <div className="hidden sm:block">
            <div className="overflow-hidden rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="bg-slate-200 dark:bg-slate-800">
                    <th className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-800 dark:text-slate-100">
                      Date
                    </th>
                    <th className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wide text-slate-800 dark:text-slate-100">
                      Détails
                    </th>
                    <th className="px-3 py-2 text-right text-[11px] font-semibold uppercase tracking-wide text-slate-800 dark:text-slate-100">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((message) => (
                    <tr
                      key={message.id}
                      className="border-t border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900"
                    >
                      <td className="px-3 py-2 whitespace-nowrap text-xs text-slate-700 dark:text-slate-200">
                        {new Date(message.created_at).toLocaleDateString(
                          "fr-FR"
                        )}
                      </td>
                      <td className="px-3 py-2 text-xs text-slate-700 dark:text-slate-200">
                        <div className="font-semibold">
                          {message.Recipient.nom} {message.Recipient.prenom}
                        </div>
                        <div className="text-xs text-primary font-bold">
                          {message.subject}
                        </div>
                        <div
                          className="text-xs mt-1 line-clamp-3"
                          dangerouslySetInnerHTML={{
                            __html: message.content,
                          }}
                        />
                      </td>
                      <td className="px-3 py-2 whitespace-nowrap">
                        <div className="flex justify-end gap-1.5">
                          <ButtonDelete
                            onClick={() => promptDeleteMessage(message.id)}
                            hoverLabel="Supprimer"
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile */}
          <div className="block sm:hidden space-y-3">
            {messages.map((message) => (
              <div
                key={message.id}
                className="rounded-xl border border-slate-200 dark:border-slate-700 p-3 shadow-sm bg-white dark:bg-slate-900"
              >
                <div className="flex justify-between items-center mb-2">
                  <span className="text-xs font-semibold text-slate-700 dark:text-slate-200">
                    {new Date(message.created_at).toLocaleDateString("fr-FR")}
                  </span>
                  <ButtonDelete
                    onClick={() => promptDeleteMessage(message.id)}
                    hoverLabel="Supprimer"
                  />
                </div>
                <div className="text-xs text-slate-700 dark:text-slate-200">
                  <div className="font-semibold">
                    {message.Recipient.nom} {message.Recipient.prenom}
                  </div>
                  <div className="text-xs text-primary font-bold">
                    {message.subject}
                  </div>
                  <div
                    className="mt-1"
                    dangerouslySetInnerHTML={{ __html: message.content }}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MessagesSent;
